import React, { useRef } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import ButtonWithDecor from '../../ui/button-with-decor'
import FooterSecondary from './footer-secondary'
// import { ScrollSmoother } from 'helpers/gsap'
import { ThemeContext } from 'helpers/ThemeProvider'

import {
  Wrapper,
  MenuWrap,
  Item,
  Li,
  Overlay,
  Primary,
  Secondary,
  Icon
} from './index.styled'

const Menu = () => {
  const {
    menuContent: { content: links }
  } = useStaticQuery(graphql`
    query MenuQuery {
      menuContent {
        content {
          primary {
            text
            url
          }
          secondary {
            text
            url
          }
        }
      }
    }
  `)

  const menuRef = useRef(null)
  const { scrollSmoother } = React.useContext(ThemeContext)

  const onClose = () => {
    /*  let scrollSmoother = ScrollSmoother.create({
      content: '.home-content',
      wrapper: '.home-wrapper',
      smooth: 2,
      effects: true,
    }) */

    menuRef.current.classList.remove('open')

    const header = document.querySelector('#header')
    header.classList.remove('open')

    const btn = document.querySelector('#menu-button')
    btn.classList.remove('open')

    scrollSmoother.current.paused(false)
  }

  return (
    <Wrapper id='menu' ref={menuRef}>
      <MenuWrap>
        {/* <CloseButton onClick={onClose} /> */}
        <Primary>
          {links.primary.map((item, index) => (
            <Li key={`primary-item-${index}`} onClick={onClose}>
              <Item to={item.url}>{item.text}</Item>
            </Li>
          ))}
        </Primary>
        <Secondary>
          {links.secondary.map((item, index) => (
            <Li key={`secondary-item-${index}`} onClick={onClose}>
              <ButtonWithDecor to={item.url} title={item.text} noBorder />
            </Li>
          ))}
          <Icon
            href='https://www.instagram.com/thehenryresidences_/'
            target='_blank'
          />
        </Secondary>

        <FooterSecondary onClose={onClose} />
      </MenuWrap>
      <Overlay onClick={onClose} />
    </Wrapper>
  )
}

export default Menu
